import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";
import { IconButton } from "@mui/material";
import "./Notification.css";
import Loader from "../Components/Loader";
import { ReactComponent as NoNotification } from "../Images/NoNotification.svg";
import { getContactPhoneApproval } from "../Store/Actions/ContactAction";
import ApprovalDialog from "./ApprovalDialog";

const Notification = ({ changePage }) => {
  const [notifications, setNotifications] = useState([]);
  const [isApprovalDialogShown, setisApprovalDialogShown] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { selectedApproval } = useSelector((state) => state.agent);
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    setIsLoading(true);

    // Fetch data on first render
    fetchData();

    // Fetch data every sixty seconds
    const interval = setInterval(() => {
      fetchData();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  // Select approval from notifications dropdown
  useEffect(() => {
    if (selectedApproval) {
      setSelectedRequest(selectedApproval);
      setisApprovalDialogShown(true);
    }
  }, [selectedApproval]);

  const fetchData = () => {
    getContactPhoneApproval(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          // process.env.NODE_ENV === "development" &&
          //   console.log("List approval", response.data.data[1]);

          setNotifications(response.data.data[1]);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="notification">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Notification</h1>
        </div>
      </div>

      <div className="container-notification">
        <header>
          <Icon height="28" icon="mdi:bell-outline" />
          <p>You have {notifications ? notifications.length : 0} Notifications</p>

          <IconButton className="close-button" onClick={() => changePage("")}>
            <Icon color="#fff" height="28" icon="ph:x-bold" />
          </IconButton>
        </header>

        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="notification-list">
              {!notifications && (
                <div className="no-notification">
                  <NoNotification height="291" width="328" />
                  <p>There are no Notification at the moment</p>
                </div>
              )}

              {notifications?.map((item, index, array) => (
                <div className="notification-item" key={index}>
                  <div className="notification-left">
                    <Icon
                      color="#3F80FF"
                      height="34"
                      icon="material-symbols:edit"
                    />

                    <div className="notification-detail">
                      <p className="notification-title">
                        Request add new Contact ({item.PhoneType}-
                        {item.ContactName?.trim()}) by {item.CreatedBy}
                      </p>

                      <p className="notification-description">
                        Request Changes on Contact ({item.ContactName?.trim()})
                      </p>
                    </div>
                  </div>

                  <div className="notification-right">
                    <div className="notification-time">
                      <Icon height="18" icon="ic:round-access-time" />
                      <p>{moment(item.CreatedTime).utc().format("HH:mm")}</p>
                    </div>

                    <button
                      className="action-button"
                      onClick={() => {
                        setSelectedRequest(
                          array.find((arrayItem) => arrayItem.ID === item.ID)
                        );

                        setisApprovalDialogShown(true);
                      }}
                    >
                      <Icon height="26" icon="ic:baseline-remove-red-eye" />
                      <p>Action</p>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <ApprovalDialog
        isOpen={isApprovalDialogShown}
        setIsApprovalDialogShown={setisApprovalDialogShown}
        request={selectedRequest}
        fetchApproval={fetchData}
      />
    </div>
  );
};

export default Notification;
